var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question-card" }, [
    _c("div", { staticClass: "question-card-header" }, [
      _c("div", [
        _c("h5", { staticClass: "question-title" }, [
          _vm._v("Question " + _vm._s(_vm.index + 1)),
        ]),
        _c("p", { staticClass: "question-body mb-0" }, [
          _vm._v(_vm._s(_vm.question.question_text)),
        ]),
      ]),
      _c("div", { staticClass: "question-actions" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default btn-sm",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [
            _c("i", {
              staticClass: "icon md-edit",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Edit "),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-danger btn-sm",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("delete")
              },
            },
          },
          [
            _c("i", {
              staticClass: "icon md-delete",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Delete "),
          ]
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "choices-grid" },
      _vm._l(_vm.choices, function (choice) {
        return _c(
          "div",
          {
            key: choice.key,
            staticClass: "choice-card",
            class: { "is-correct": _vm.isCorrect(choice.answer) },
          },
          [
            _c("div", { staticClass: "choice-label" }, [
              _vm._v(_vm._s(choice.label)),
            ]),
            _c("div", { staticClass: "choice-value" }, [
              _vm._v(_vm._s(choice.value)),
            ]),
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "question-footer" }, [
      _c("span", { staticClass: "bonus-time" }, [
        _vm._v("Extra time: " + _vm._s(_vm.question.bonus_time) + " seconds"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }